//
export default [
    {
        text: '#',
        value: 'id',
        sortable: true,
    },
    {
        text: 'código',
        value: 'code',
        sortable: true,
    },
    {
        text: 'creado por',
        value: 'g_user_hr_employee_full_name',
    },
    {
        text: 'autorizado por',
        value: ({ g_authorizer_user }) =>
            g_authorizer_user
                ? g_authorizer_user.hr_employee.names +
                  ' ' +
                  g_authorizer_user.hr_employee.last_name1 +
                  ' ' +
                  g_authorizer_user.hr_employee.last_name2
                : '-',
    },
    {
        text: 'monto a pagar',
        value: 'amount_to_pay',
        align: 'right',
        format: 'currency',
    },
    {
        text: 'estado',
        value: 'state_name',
        align: 'center',
        component: {
            type: 'chip-label',
            props: {
                palette: {
                    autorizado: 'success lighten-3',
                    creado: 'accent lighten-3',
                    pagado: 'grey darken-4 white--text',
                    rechazado: 'error lighten-3',
                },
                small: true,
            },
        },
    },
    {
        text: 'pago',
        value: 'payment_date',
        align: 'right',
        format: 'date',
        sortable: true,
    },
    {
        text: 'creación',
        value: 'created_at',
        align: 'right',
        format: 'datetime',
        sortable: true,
    },
]
